import { render, staticRenderFns } from "./OptionCustomFieldSelectAndEditComp.vue?vue&type=template&id=5f7283ca"
import script from "./OptionCustomFieldSelectAndEditComp.vue?vue&type=script&lang=ts"
export * from "./OptionCustomFieldSelectAndEditComp.vue?vue&type=script&lang=ts"
import style0 from "./OptionCustomFieldSelectAndEditComp.vue?vue&type=style&index=0&id=5f7283ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports